import React from 'react'
import MetricsWidget from '../HomeDashboard/visualizations/metricsWidget'
import ApprovalDashboard from '../HomeDashboard/ApprovalDashboard'
import MyTask from '../HomeDashboard/MyTask'
import Pie from '../HomeDashboard/visualizations/pie'
import Logbook from '../ModalComponents/LogBook'
import Bar from '../HomeDashboard/visualizations/Bar'
import Heatmap from '../HomeDashboard/visualizations/Heatmap'
import Line from '../HomeDashboard/visualizations/Line'
import Radar from '../HomeDashboard/visualizations/Radar'
import Funnel from '../HomeDashboard/visualizations/Funnel'
import DailyOpeningClosingStock from '../HomeDashboard/DailyOpeningClosingStock'
import TabularReportViewer from '../HomeDashboard/visualizations/TabularReportViewer'

const Visuals = ({component, type, reportId, onMetricsChange, isEditingWindow, getHighlightRowStyle}) => {

  return (
    <>
    {type === 'radar' && (
        <Radar reportId={reportId} />
    )}
    {type === 'line' && (
        <Line reportId={reportId}/>
    )}
    {type === 'bar' && (
        <Bar reportId={reportId}/>
    )}
    {type === 'metric' && (
        <MetricsWidget onMetricsChange={onMetricsChange} mtrics={component.metrics} isEditingWindow={isEditingWindow} />
    )}
    {type === 'pie' && (
        <Pie reportId={reportId}/>
    )}
    {type === 'funnel' && (
        <Funnel reportId={reportId}/>
    )}
    {type === 'approval' && (
        <ApprovalDashboard />
    )}
    {type === 'myTasks' && (
        <MyTask />
    )}
    {type === 'logBook' && (
        <Logbook />
    )}
    {type === 'heatmap' && (
        <Heatmap reportId={reportId} />
    )}
    {/* {type === 'dailyOpeningClosingStock' && (
        <DailyOpeningClosingStock />
    )} */}
    {type === 'table' && (
        <TabularReportViewer reportId={reportId} getHighlightRowStyle={getHighlightRowStyle} component={component} />
    )}
    </>
  )
}

export default Visuals
